import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  cards: number;
  lines: number;
}


import { computed } from 'vue';

import { clamp } from '@tools/math';

interface CardLine {
  key: number;
  width: string;
}

interface CardInstance {
  key: number;
  transitionDelay: string;
  lines: CardLine[];
}

declare module 'vue/types/vue' {
  export interface Vue {
    CardLoadPlaceholder: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardLoadPlaceholder' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cards: null,
    lines: null
  },
  setup(__props: any) {

const props = __props as {
  cards: number;
  lines: number;
};

/**
 * `CardLoadPlaceholder` component properties.
 */


function createInstances(cardCount: number, lineCount: number) {
  const instances: CardInstance[] = [];

  for (let n = 0; n < cardCount; n++) {
    const transitionDelay = `${n * 0.1}s`;
    const lines = createLines(lineCount);

    instances.push({ key: n, transitionDelay, lines });
  }

  return instances;
}

function createLines(lineCount: number) {
  const lines: CardLine[] = [];

  for (let n = 0; n < lineCount; n++) {
    const w = clamp(Math.random(), 0.2, 0.8) * 100;

    lines.push({ key: n, width: `${w}%` });
  }

  return lines;
}

const instances = computed(() => {
  return createInstances(props.cards, props.lines);
});

return { __sfc: true,props, createInstances, createLines, instances }
}

})